import { Box, Button, Typography, styled } from '@mui/material'

export const SearchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  gap: 0,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    alignItems: 'stretch',
  },
}))

export const SaveConfirmationCard = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '16px',
  padding: theme.spacing(4),
  textAlign: 'center',
  marginBottom: theme.spacing(3),
  boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
}))

export const SaveConfirmationTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.grey[900],
  marginBottom: theme.spacing(2),
  fontSize: '28px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '24px',
  },
}))

export const SaveConfirmationMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[700],
  marginBottom: theme.spacing(1.5),
  lineHeight: 1.6,
  fontSize: '16px',
  maxWidth: '600px',
  margin: '0 auto',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}))

export const SaveConfirmationSecondaryMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[500],
  lineHeight: 1.5,
  fontSize: '14px',
  maxWidth: '600px',
  margin: '0 auto',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('sm')]: {
    fontSize: '13px',
  },
}))

export const OpenInAppButton = styled(Button)(({ theme }) => ({
  borderRadius: '24px',
  padding: '12px 32px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  marginTop: theme.spacing(2),
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    padding: '10px 24px',
  },
}))

export const RestaurantsSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(6),
  marginBottom: theme.spacing(3),
  [theme.breakpoints.down('sm')]: {
    marginTop: theme.spacing(4),
  },
}))

export const BackToHomeButton = styled(Button)(({ theme }) => ({
  width: '100%',
  borderRadius: '24px',
  padding: '14px 24px',
  textTransform: 'none',
  fontSize: '16px',
  fontWeight: 600,
  borderColor: theme.palette.grey[900],
  color: theme.palette.grey[900],
  borderWidth: '2px',
  marginTop: theme.spacing(2),
  '&:hover': {
    borderWidth: '2px',
    backgroundColor: theme.palette.grey[50],
    borderColor: theme.palette.grey[900],
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
    padding: '12px 20px',
  },
}))
